import {
    SET_FILTER_DATA,
    TOGGLE_FILTER
} from '../types'

export default (state = {filter: {}, isOpen: false}, action) => {
    const newState = {...state}
    if(action.filterType && !newState.filter[action.filterType]){
        newState.filter[action.filterType] = {}
    }
    switch (action.type) {
        case TOGGLE_FILTER:
            newState.isOpen = typeof action.payload !== "undefined" ? action.payload : !newState.isOpen
            return newState
        case SET_FILTER_DATA:
            newState.filter[action.filterType] = action.payload
            return newState
        default:
            return state
    }
}